import { createGlobalStyle } from 'styled-components';

const NoHTMLScroll = createGlobalStyle`
  html,body {overflow: hidden;} 
`;

export default NoHTMLScroll;
